import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as api from './api';

export const initialized = createAction(types.INITIALIZED);
export const cleanup = createAction(types.CLEANUP);
export const updateLastUsedDC = createAction(types.UPDATE_LAST_USED_DC);
export const dismissExpiredTrialModal = createAction(types.DISMISS_EXPIRED_TRIAL_MODAL);
export const dismissUnverifiedAlert = createAction(types.DISMISS_UNVERIFIED_ALERT);

export const getCordToken = createApiAction(
  types.GET_CORD_TOKEN,
  () => api.getCordToken()
    .then(({ data }) => data)
    .catch(() => {}),
);

export const getUserAttributes = createApiAction(
  types.GET_USER_ATTRIBUTES,
  () => api.getUserAttributes()
    .then((attributes) => attributes)
    .catch(() => {}),
);
